const state = () => ({
  signatureConfig: {
    field: '',
    isCover: false,
    secretFree: false,
    password: '',
  },
  //签章status:disable(未启用)，start（开始），ing(进行中)，success(成功)，fail(失败)
  signatureStatus: 'disable',
})
const getters = {}

const mutations = {
  setSignatureConfig(state, configInfo) {
    state.signatureConfig = configInfo
  },
  setSignatureStatus(state, status) {
    state.signatureStatus = status
  },
  initSignatureConfig(state) {
    state.signatureConfig = {
      field: '',
      isCover: false,
      secretFree: false,
      password: '',
    }
    state.signatureStatus = 'disable'
  },
}
const actions = {}
export default { state, getters, mutations, actions }
